import React, { FC } from 'react';
import formatPriceNumber from 'utils/formatPrice';
import AllItemsCardLoader from 'components/Loaders/AllItemsCard';
import RatingsCardLoader from 'components/Loaders/RatingsCardProduct';
import useConnect from './connect';
import {
  Container,
  TwoColumns,
  TwoRows,
  Section,
  Title,
  Caption,
  CaptionWrapper,
  CaptionButton,
  AllItemsCard,
  RatingsCard,
  Row,
  Header,
  ArrowDown,
  ArrowUp,
  Item,
  Position,
  CircledNumber,
  Number,
  NameWrapper,
  Name,
  // PickerContainer,
  // DatesSelector,
  // DateCaption,
} from './styles';
import { Props } from './types';

const Product: FC<Props> = ({ brandId }) => {
  const {
    product,
    isLoading,
    orderBy,
    handleUpdateOrder,
    itemsOrdered,
    // hoverRange,
    // selectedDays,
    // handleDayChange,
    // handleDayEnter,
    // handleDayLeave,
    // handleWeekClick,
  } = useConnect({
    brandId,
  });

  return (
    <Container>
      {/* <PickerContainer>
        <DateCaption>Date range</DateCaption>
        <DatesSelector
          hoverRange={hoverRange}
          selectedDays={selectedDays}
          handleDayChange={handleDayChange}
          handleDayEnter={handleDayEnter}
          handleDayLeave={handleDayLeave}
          handleWeekClick={handleWeekClick}
        />
      </PickerContainer> */}
      <TwoColumns>
        <Section>
          <Title>All items</Title>
          <AllItemsCard>
            {!product || isLoading ? (
              <>
                <AllItemsCardLoader opacity={1} />
                <AllItemsCardLoader opacity={0.9} />
                <AllItemsCardLoader opacity={0.8} />
                <AllItemsCardLoader opacity={0.7} />
                <AllItemsCardLoader opacity={0.6} />
                <AllItemsCardLoader opacity={0.5} />
                <AllItemsCardLoader opacity={0.4} />
                <AllItemsCardLoader opacity={0.3} />
                <AllItemsCardLoader opacity={0.2} />
                <AllItemsCardLoader opacity={0.1} />
                <AllItemsCardLoader opacity={0} />
              </>
            ) : (
              <>
                <Header>
                  <Caption>Item</Caption>
                  <Caption>Count</Caption>
                  <CaptionWrapper>
                    <CaptionButton
                      type="button"
                      onClick={() =>
                        handleUpdateOrder(orderBy === 'desc' ? 'asc' : 'desc')
                      }
                    >
                      {orderBy === 'desc' ? <ArrowDown /> : <ArrowUp />}
                      <Caption>Sales</Caption>
                    </CaptionButton>
                  </CaptionWrapper>
                </Header>
                {itemsOrdered?.map((item, index) => (
                  <Row key={item.name}>
                    <NameWrapper>
                      <Position>{index + 1}</Position>
                      <Name>{item.name}</Name>
                    </NameWrapper>
                    <Number>{item.count}</Number>
                    <Number>{formatPriceNumber(item.sales)}</Number>
                  </Row>
                ))}
              </>
            )}
          </AllItemsCard>
        </Section>
        <TwoRows>
          <Section>
            <Title>Top 5 sold items</Title>
            {!product || isLoading ? (
              <RatingsCardLoader />
            ) : (
              <>
                <RatingsCard>
                  <Caption>Item Name</Caption>
                  {product.topItems.map((item, index) => (
                    <Item key={item}>
                      <CircledNumber>{index + 1}</CircledNumber>
                      <Name>{item}</Name>
                    </Item>
                  ))}
                </RatingsCard>
              </>
            )}
          </Section>
          <Section>
            <Title>Least 5 sold items</Title>
            {!product || isLoading ? (
              <RatingsCardLoader />
            ) : (
              <RatingsCard>
                {product.bottomItems.map((item, index) => (
                  <Item key={item}>
                    <CircledNumber>{index + 1}</CircledNumber>
                    <Name>{item}</Name>
                  </Item>
                ))}
              </RatingsCard>
            )}
          </Section>
        </TwoRows>
      </TwoColumns>
    </Container>
  );
};

export default Product;
